import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MenuItem = styled.span`
  font-size: 1rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.2s ease;
  opacity: 1;
  ${({ ishide }: { ishide?: boolean }) =>
    ishide && "display: none; opacity: 0; "}
  &:hover {
    transition: all 0.2s ease;
    background-color: #f2f2f2;
    border-radius: 0.5rem;
  }
  & > svg {
    margin-right: 0.5rem;
  }
`;
